import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';

/**
 * Form de inscriere la newsletter. Variant: "inline" (Footer) sau "card" (Landing).
 * Trimite POST /api/public/newsletter cu email + source.
 */
export default function NewsletterSignup({ variant = 'inline', source = 'unknown' }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes('@')) { setStatus('error'); setMessage(t('app.newsletter.invalid_email')); return; }
    setStatus('loading');
    try {
      const res = await api.post('/api/public/newsletter', { email, source });
      if (res.data?.success) {
        setStatus('success');
        setMessage(res.data.message || t('app.newsletter.success'));
        setEmail('');
      } else {
        setStatus('error');
        setMessage(res.data?.message || t('app.newsletter.error_generic'));
      }
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.detail || t('app.newsletter.error_network'));
    }
  };

  if (variant === 'card') {
    return (
      <div style={{
        background: '#fff',
        borderRadius: 14,
        padding: '32px 28px',
        boxShadow: '0 18px 40px rgba(15,23,42,0.08)',
        border: '1px solid #E5E7EB',
        textAlign: 'center',
      }}>
        <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 26, fontWeight: 700, color: '#0A1428', marginBottom: 8 }}>
          {t('app.newsletter.card_title')}
        </h3>
        <p style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: 15, lineHeight: 1.6, color: '#6B7280', marginBottom: 20 }}>
          {t('app.newsletter.card_description')}
        </p>
        <form onSubmit={submit} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder={t('app.newsletter.placeholder_card')}
            style={{
              flex: 1, minWidth: 200, padding: '12px 16px',
              border: '1px solid #E5E7EB', borderRadius: 8, fontFamily: 'Inter, system-ui, sans-serif', fontSize: 15,
              outline: 'none',
            }}
            disabled={status === 'loading' || status === 'success'}
          />
          <button type="submit" disabled={status === 'loading' || status === 'success'} style={{
            padding: '12px 24px',
            background: status === 'success' ? '#2d6a4f' : '#0A1428',
            color: '#fff', border: 'none', borderRadius: 8,
            fontFamily: 'DM Mono, monospace', fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700,
            cursor: status === 'loading' ? 'wait' : 'pointer',
          }}>
            {status === 'success' ? `✓ ${t('app.newsletter.subscribed')}` : status === 'loading' ? '...' : t('app.newsletter.subscribe')}
          </button>
        </form>
        {message && (
          <p style={{
            marginTop: 12, fontFamily: 'DM Mono, monospace', fontSize: 12,
            color: status === 'success' ? '#2d6a4f' : status === 'error' ? '#c0392b' : '#6B7280',
          }}>
            {message}
          </p>
        )}
      </div>
    );
  }

  // Inline (Footer)
  return (
    <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', gap: 6 }}>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder={t('app.newsletter.placeholder_inline')}
          style={{
            flex: 1, padding: '8px 12px',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: 6, fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13,
            background: 'rgba(255,255,255,0.06)', color: '#fff', outline: 'none',
          }}
          disabled={status === 'loading' || status === 'success'}
        />
        <button type="submit" disabled={status === 'loading' || status === 'success'} style={{
          padding: '8px 14px',
          background: status === 'success' ? '#2d6a4f' : '#D4AF37',
          color: '#0A1428', border: 'none', borderRadius: 6,
          fontFamily: 'DM Mono, monospace', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', fontWeight: 700,
          cursor: 'pointer',
        }}>
          {status === 'success' ? '✓' : status === 'loading' ? '...' : t('app.newsletter.go')}
        </button>
      </div>
      {message && (
        <p style={{ fontFamily: 'DM Mono, monospace', fontSize: 11, color: status === 'success' ? '#86efac' : status === 'error' ? '#fca5a5' : '#9CA3AF', margin: 0 }}>
          {message}
        </p>
      )}
    </form>
  );
}
